// Socket connection disabled - using mock socket
export const socket = {
  on: () => {},
  off: () => {},
  emit: (event, data, callback) => {
    if (typeof callback === "function") {
      callback({ signature: "dummy_signature", nonce: "dummy_nonce" });
    }
  },
  disconnect: () => {},
};
